import React from 'react';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// @material-ui/icons
// core components
import GridContainer from 'components/Grid/GridContainer.jsx';

import userProfileStyles from 'assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx';
import UserDetails from './UserProfile';
import SkidataUserOrders from './SkidataUserOrders';
import MgbUserOrders from './MgbUserOrders';
import BlsUserOrders from './BlsUserOrders';
import { AuthConsumer } from '../../../auth/AuthContext';
import tenantRoles from '../../../auth/tenantRoles';

function UserProfile(props) {
  const { match, history } = props;

  function onSkidataOrderSelect(orderId) {
    history.push(`/partner/zbag/${orderId}`);
  }

  function onMgbOrderSelect(orderId) {
    history.push(`/partner/mgb/${orderId}`);
  }

  function onBlsOrderSelect(orderId) {
    history.push(`/partner/bls/${orderId}`);
  }

  const userId = match.params.id;

  return (
    <AuthConsumer>
      {({ isAuthorized }) => (
        <div>
          <GridContainer>
            <UserDetails userId={userId} />
            {isAuthorized([tenantRoles.SKIDATA_ADMIN_READ]) ? (
              <SkidataUserOrders
                userId={userId}
                onOrderSelect={onSkidataOrderSelect}
              />
            ) : null}
            {isAuthorized([tenantRoles.MGB_ADMIN_READ]) ? (
              <MgbUserOrders userId={userId} onOrderSelect={onMgbOrderSelect} />
            ) : null}
            {isAuthorized([tenantRoles.BLS_ADMIN_READ]) ? (
              <BlsUserOrders userId={userId} onOrderSelect={onBlsOrderSelect} />
            ) : null}
          </GridContainer>
        </div>
      )}
    </AuthConsumer>
  );
}

export default withStyles(userProfileStyles)(UserProfile);



// WEBPACK FOOTER //
// ./src/views/users/components/User.jsx